import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./style/theme/main.css";
import "./style/theme/common.css";
import "./style/theme/realvirtual.css";
import "./style/theme/purple.css";
import "./style/theme/blue.css";
import "./style/theme/green.css";
import "./style/theme/orange.css";
import "./style/tokens.css";
import "./style/wizard.css";
import "./style/pin.css";

import App from "./App";
import StoreCheckout from "./checkout/StoreCheckout";
import { applyTheme } from "./lib/theme";
import { migrateLegacyStorageKeys } from "./lib/storage";
import { CURRENT_BRAND } from "./brand/config";

// KBP-21: rename pre-scoped storage keys into the tenant-scoped namespace
// BEFORE any module reads from storage (applyTheme below is the first
// consumer). Idempotent — safe on every boot.
migrateLegacyStorageKeys();

document.title = `${CURRENT_BRAND.displayName} — Onboarding`;
applyTheme();

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      {location.pathname === '/checkout' ? <StoreCheckout /> : <App />}
    </QueryClientProvider>
  </StrictMode>,
);
